import { Injectable, EventEmitter } from '@angular/core';
import { SvNotificationStatus } from 'sv-chemistry-ng-lib';

export class SvNotification {
  type: SvNotificationStatus;
  message: string;
  constructor(type: SvNotificationStatus = SvNotificationStatus.None, message: string){
    this.type = type;
    this.message = message;
  }
}

@Injectable({
  providedIn: 'root'
})
export class PageLevelNotificationService {
  public opened: EventEmitter<SvNotification> = new EventEmitter();
  public closed: EventEmitter<boolean> = new EventEmitter();
  constructor() { }

  showNotification(notification: SvNotification, timeoutMs?: number){
    this.opened.emit(notification);
    if(timeoutMs){
      setTimeout(_ => {
        this.closeNotification();
      }, timeoutMs)
    }
  }

  closeNotification() {
    this.closed.emit(true);
  }}
